module.exports = __webpack_public_path__ + "media/10.5918f1d2.mp3";